import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as authAPI from 'lib/api/auth';
import { initialize } from 'modules/authSlice';
import { useQuery } from 'react-query';
import { getNotiCheck } from 'lib/api/dashboard';
import useLoginCheck from 'hooks/common/useLoginCheck';

const useHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const name = localStorage.getItem('username');

  const { accessToken } = useSelector(({ auth }) => auth);

  const { data, error, refetch } = useQuery('notiCheck', getNotiCheck);
  useLoginCheck(error?.response, refetch);

  const logout = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');

      await authAPI.logout(accessToken, refreshToken);

      dispatch(initialize());

      localStorage.clear();

      navigate('/');
    } catch (e) {
      throw e.response.data.msg;
    }
  };

  return { name, data, refetch, logout };
};

export default useHeader;
